/**
 * Iter-158.3 — Beta · Hair & Makeup persistent indicator.
 *
 * A subtle amber pill rendered above the page content on every screen
 * inside the beta H&M workspace. Producers who used the legacy app get
 * a visual reminder that this workspace is isolated beta and that any
 * changes they make here do not affect their live legacy project.
 */
export default function BetaHmIndicator() {
    return (
        <div
            data-testid="beta-hm-indicator"
            className="w-full flex justify-center pt-2 pb-1"
        >
            <span className="inline-flex items-center gap-1.5 rounded-full border border-amber-500/40 bg-amber-500/10 px-3 py-1 text-[10px] uppercase tracking-[0.24em] text-amber-200">
                <span className="h-1.5 w-1.5 rounded-full bg-amber-400" />
                Beta · Hair &amp; Makeup
            </span>
        </div>
    );
}
